import { Box } from "@mui/system";
import React from "react";
import FooterNote from "../Components/FoooterNote/FooterNote";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderNote from "../Components/HeaderNote/HeaderNote";
import ProductCard from "../Components/PorductCard/ProductCard";
import SummarySection from "../Components/SummarySection/SummarySection";
import SummaryStickySection from "../Components/SummaryStickySection/SummaryStickySection";
import SectionTitle2 from "../Components/Ui-Components/SectionTitle2/SectionTitle2";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Button, Fab } from "@mui/material";
import ProductCardVideo from "../Components/PorductCard/ProductCardVideo";
import FontHelper from "../Helpers/FontHelper";
import ColorHelper from "../Helpers/ColorHelper";
import IconHelper from "../Helpers/IconHelper";
import FilledButton from "../Components/Ui-Components/Buttons/FilledButton/FilledButton";
import { clearCart } from "../redux/shoppingActions";
import LoaderComp from "../Components/Loader/LoaderComp";
import { FaCommentsDollar } from "react-icons/fa";
import PrivacyPolicyModal from "../Components/Modals/PrivacyPolicyModal/PrivacyPolicyModal";
import { KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";
function TabPanel(props) {
  const { children, value, index, ...other } = props;


  const state = useSelector((state) => state);
  useEffect(() => {
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
    window.scrollTo(0, 100);
    window.scrollTo(0, 0);
    localStorage.setItem("currPage", "labeled");
  }, []);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ProductPage = () => {
  const location = useLocation();

  const state = useSelector((state) => state.shop.products);
  const cartDetails = useSelector((state) => state.shop?.cartInfo);
  const [reportedPhoto, setReportedPhoto] = useState([]);
  const navigate = useNavigate();

  const [reportPics, setReportPics] = useState(false);

  const reportPicsHandle = () => {
    setReportPics(!reportPics);
  };

  const [value, setValue] = React.useState(0);
  const [loadPage, setLoadPage] = React.useState(false);
  const [privacyVerified, setPrivacyVerified] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [isNearBottom, setIsNearBottom] = useState(false);
  const itemsPerPage = 25;
  const paginationRef = React.useRef(null);

  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Pagination logic
  const getPaginatedData = () => {
    if (!state?.photo) return [];
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return state.photo.slice(startIndex, endIndex);
  };

  const getTotalPages = () => {
    if (!state?.photo) return 0;
    return Math.ceil(state.photo.length / itemsPerPage);
  };

  const handleNextPage = () => {
    if (currentPage < getTotalPages()) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getVisiblePages = () => {
    const totalPages = getTotalPages();
    const maxPagesToShow = window.innerWidth < 768 ? 2 : 5;
    // const maxPagesToShow = 5;

    // // If total pages is 7 or less, show all pages
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    let startPage, endPage;

    // Calculate the range based on current page position
    if (currentPage <= 3) {
      startPage = 1;
      endPage = 5;
    } else if (currentPage >= totalPages - 2) {
      startPage = totalPages - 4;
      endPage = totalPages;
    } else {
      startPage = currentPage - 2;
      endPage = currentPage + 2;
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const renderPaginationButtons = () => {
    const totalPages = getTotalPages();
    const visiblePages = getVisiblePages();

    // If 7 or fewer pages, show all without ellipsis
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
        <Button
          key={pageNumber}
          onClick={() => handlePageClick(pageNumber)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 9, md: 12 },
            minWidth: { xs: 28, md: 45 },
            height: { xs: 28, md: 40 },
            padding: { xs: "2px", md: "8px" },
            backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#FFFFFF",
            color: currentPage === pageNumber ? ColorHelper.WhiteColor : ColorHelper.BlackColor,
            border: currentPage === pageNumber ? `2px solid #3f0e77` : "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: currentPage === pageNumber ? "bold" : "normal",
            flexShrink: 0,
            "&:hover": {
              backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#F0F0F0",
              borderColor: currentPage === pageNumber ? "#3f0e77" : "#D0D0D0",
            },
          }}
        >
          {pageNumber}
        </Button>
      ));
    }

    const buttons = [];
    const firstPage = visiblePages[0];
    const lastPage = visiblePages[visiblePages.length - 1];

    // Show first page if not in visible range
    if (firstPage > 1) {
      buttons.push(
        <Button
          key={1}
          onClick={() => handlePageClick(1)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 35, md: 45 },
            height: { xs: 35, md: 40 },
            backgroundColor: "#FFFFFF",
            color: ColorHelper.BlackColor,
            border: "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            padding: { xs: "4px", md: "8px" },
            flexShrink: 0,
            "&:hover": { backgroundColor: "#F0F0F0" },
          }}
        >
          1
        </Button>
      );
      if (firstPage > 2) {
        buttons.push(
          <Typography key="start-ellipsis" sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 }, flexShrink: 0 }}>
            ...
          </Typography>
        );
      }
    }

    // Show visible pages
    visiblePages.forEach((pageNumber) => {
      buttons.push(
        <Button
          key={pageNumber}
          onClick={() => handlePageClick(pageNumber)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 35, md: 45 },
            height: { xs: 35, md: 40 },
            backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#FFFFFF",
            color: currentPage === pageNumber ? ColorHelper.WhiteColor : ColorHelper.BlackColor,
            border: currentPage === pageNumber ? `2px solid #3f0e77` : "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: currentPage === pageNumber ? "bold" : "normal",
            padding: { xs: "4px", md: "8px" },
            flexShrink: 0,
            "&:hover": {
              backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#F0F0F0",
              borderColor: currentPage === pageNumber ? "#3f0e77" : "#D0D0D0",
            },
          }}
        >
          {pageNumber}
        </Button>
      );
    });

    // Show last page if not in visible range
    if (lastPage < totalPages) {
      if (lastPage < totalPages - 1) {
        buttons.push(
          <Typography key="end-ellipsis" sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 }, flexShrink: 0 }}>
            ...
          </Typography>
        );
      }
      buttons.push(
        <Button
          key={totalPages}
          onClick={() => handlePageClick(totalPages)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 35, md: 45 },
            height: { xs: 35, md: 40 },
            backgroundColor: "#FFFFFF",
            color: ColorHelper.BlackColor,
            border: "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            padding: { xs: "4px", md: "8px" },
            flexShrink: 0,
            "&:hover": { backgroundColor: "#F0F0F0" },
          }}
        >
          {totalPages}
        </Button>
      );
    }

    return buttons;
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToPagination = () => {
    if (paginationRef.current) {
      paginationRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    document.title = state.eventName + " | Select Photos";
  }, []);

  // Handle scroll for back to top button
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = (scrollTop / docHeight) * 100;

      setShowBackToTop(scrollTop > 300);
      setIsNearBottom(scrollPercentage > 70);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // useEffect(() => {
  //   if (data.thresholdPhotoCount) {
  //     console.log("thresholdData-----", data.thresholdPhotoCount);
  //   }
  // }, [data.thresholdPhotoCount]);

  return (
    <Box
      sx={{
        "#ImageTabPanel-TZ, #VideoTabPanel-TZ": {
          "> div": {
            px: "0px",
          },
        },
      }}
    >
      {state.photo ? (
        <>
          <Header />
          <SectionTitle2
            title={state.eventName}
            eventLogo={state.eventLogo}
            eventLogoShow={true}
            page={"products"}
          />
          <PrivacyPolicyModal privacyPolicy={state?.participantExists[0]} productInfo={state} />
          <HeaderNote priceInfo={state.priceInfo} />
          <SummarySection
            bibNumber={state.bibNumber}
            eventName={state.eventName}
            cartDetails={cartDetails}
            ReportBtn={true}
            unlabledPage="false"
            reportPics={reportPics}
            setReportedPhoto={setReportedPhoto}
            reportPicsHandle={reportPicsHandle}
            reportedPhoto={reportedPhoto}
            imagesCount={state.photo.length}
          />
          {!(state?.isVerified !== true && state?.isPrivacyCheckEnabled === true) ? <Box
            sx={{
              width: "100%",
              px: { xs: 5, sm: 5, md: 5, lg: 10 },
              "#TabsContainer": {
                width: "min-content",
                margin: { xs: "auto", sm: "unset" },
              },
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              id="TabsContainer"
              sx={{
                color: ColorHelper.WhiteColor,
                borderRadius: "0px 0px 5px 5px",
                ".MuiTabs-indicator": {
                  display: "none",
                },
                ".Mui-selected": {
                  color: ColorHelper.WhiteColor,
                  backgroundColor: ColorHelper.PinkColor,
                  "svg path": {
                    fill: ColorHelper.WhiteColor,
                  },
                  "#PhotoTab, #VideoTab ": {
                    color: ColorHelper.WhiteColor,
                  },
                },
              }}
            >
              <Tab
                sx={{
                  color: ColorHelper.LightGrey8,
                  borderRadius: "0px 0px 0px 5px",
                }}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: { xs: 1, md: 2 },
                    }}
                  >
                    <IconHelper.PhotoIcon />
                    <Typography
                      sx={{
                        color: ColorHelper.LightGrey8,
                        fontFamily: FontHelper.fBold,
                        fontSize: { xs: 12, md: 16 },
                      }}
                      id="PhotoTab"
                    >
                      Photos
                    </Typography>
                  </Box>
                }
                {...a11yProps(0)}
              />
              {state.video?.length !== 0 ? (
                <Tab
                  sx={{
                    color: ColorHelper.LightGrey8,
                    borderRadius: "0px 0px 5px 0px",
                  }}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <IconHelper.VideoIcon />
                      <Typography
                        sx={{
                          color: ColorHelper.LightGrey8,
                          fontFamily: FontHelper.fBold,
                          fontSize: { xs: 12, md: 16 },
                        }}
                        id="VideoTab"
                      >
                        Videos
                      </Typography>
                    </Box>
                  }
                  {...a11yProps(1)}
                />
              ) : null}
            </Tabs>
            {new Date().getTime() >
              new Date(localStorage?.getItem("awsImageExpiry")).getTime() ? (
              <Box
                sx={{
                  border: "1px solid #F5EAEA",
                  borderRadius: "10px",
                  px: "20px",
                  py: "50px",
                  display: "grid",
                  placeItems: "center",
                  my: "50px",
                  fontWeight: "bold",
                }}
              >
                <span style={{}}>
                  Oops !!..Your search session is expired please serach again
                  get the valid images
                </span>
                <FilledButton
                  handleClick={() => {
                    localStorage?.removeItem("awsImageExpiry");
                    navigate("/home");
                    dispatch(clearCart());
                  }}
                  btnText={"Go back"}
                  color={ColorHelper.PrimaryColor}
                  bgColor={ColorHelper.WhiteColor}
                  bordercolor={ColorHelper.WhiteColor}
                  sx={{
                    position: "relative",
                    fontFamily: FontHelper.fSemiBold,
                    fontWeight: 500,
                    fontSize: { xs: 12, md: 16 },
                    height: { xs: "40px", sm: "50px" },
                    px: "19px",
                    fontWeight: 600,
                    my: "20px",
                  }}
                  cstHover={{
                    "&:hover": {
                      backgroundColor: ColorHelper.PrimaryColorLight,
                      color: ColorHelper.WhiteColor,
                    },
                  }}
                />
              </Box>
            ) : (
              <>
                <TabPanel value={value} index={0} id="ImageTabPanel-TZ">
                  <ProductCard
                    photo={getPaginatedData()}
                    stateDetails={state}
                    cartDetails={cartDetails}
                    reportPics={reportPics}
                    setReportedPhoto={setReportedPhoto}
                    loadPage={loadPage}
                    setLoadPage={setLoadPage}
                  />
                </TabPanel>
                <TabPanel value={value} index={1} id="VideoTabPanel-TZ">
                  <ProductCardVideo
                    photo={state.video}
                    stateDetails={state}
                    cartDetails={cartDetails}
                    reportPics={reportPics}
                  />
                </TabPanel>

                {/* Pagination Controls for Photo Tab */}
                {value === 0 && state?.photo?.length > itemsPerPage && (
                  <Box
                    ref={paginationRef}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: { xs: 0.2, md: 2 },
                      mt: 4,
                      mb: 4,
                      px: 0,
                      width: "100%",
                      flexWrap: "nowrap",
                      backgroundColor: "#F5F5F5",
                      padding: { xs: "8px 4px", md: "20px 40px" },
                      borderTop: "1px solid #E0E0E0",
                      borderBottom: "1px solid #E0E0E0",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      overflowX: { xs: "auto", md: "visible" },
                    }}
                  >
                    <Button
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                      sx={{
                        fontFamily: FontHelper.fBold,
                        fontSize: { xs: 9, md: 13 },
                        minWidth: "auto",
                        backgroundColor: currentPage === 1 ? "#D4D4D4" : "#3f0e77",
                        color: currentPage === 1 ? "#999999" : ColorHelper.WhiteColor,
                        px: { xs: 2, md: 2.5 },
                        py: { xs: 0.5, md: 1.2 },
                        borderRadius: "6px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        textTransform: "none",
                        border: "none",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        "&:hover": {
                          backgroundColor: currentPage === 1 ? "#D4D4D4" : "#3f0e77",
                        },
                        height: { xs: 28, md: 40 },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                      }}
                    >
                      <Box sx={{ display: { xs: "none", md: "block" } }}>← Previous</Box>
                      <Box sx={{ display: { xs: "block", md: "none" }, fontSize: 14, }}>←</Box>
                    </Button>

                    <Box sx={{
                      display: "flex",
                      gap: { xs: 0.2, md: 0.8 },
                      mx: { xs: 0.6, md: 0 },
                      flexWrap: "nowrap",
                    }}>
                      {renderPaginationButtons()}
                    </Box>

                    <Button
                      onClick={handleNextPage}
                      disabled={currentPage === getTotalPages()}
                      sx={{
                        fontFamily: FontHelper.fBold,
                        fontSize: { xs: 9, md: 13 },
                        minWidth: "auto",
                        backgroundColor:
                          currentPage === getTotalPages() ? "#D4D4D4" : "#3f0e77",
                        color:
                          currentPage === getTotalPages() ? "#999999" : ColorHelper.WhiteColor,
                        px: { xs: 2, md: 2.5 },
                        py: { xs: 0.5, md: 1.2 },
                        borderRadius: "6px",
                        cursor:
                          currentPage === getTotalPages()
                            ? "not-allowed"
                            : "pointer",
                        textTransform: "none",
                        border: "none",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        "&:hover": {
                          backgroundColor:
                            currentPage === getTotalPages()
                              ? "#D4D4D4"
                              : "#3f0e77",
                        },
                        height: { xs: 28, md: 40 },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                      }}
                    >
                      <Box sx={{ display: { xs: "none", md: "block" } }}>Next →</Box>
                      <Box sx={{ display: { xs: "block", md: "none" }, fontSize: 14 }}>→</Box>
                    </Button>
                  </Box>
                )}

                {/* Animated Back to Top / Go to Pagination Button */}
                {showBackToTop && (
                  <Fab
                    onClick={isNearBottom ? scrollToTop : scrollToPagination}
                    sx={{
                      position: "fixed",
                      bottom: { xs: 90, md: 100 },
                      right: { xs: 8, md: 12 },
                      backgroundColor: "#3f0e77",
                      color: ColorHelper.WhiteColor,
                      zIndex: 1000,
                      transition: "all 0.3s ease",
                      "@keyframes spinUp": {
                        "0%": { transform: "translateY(10px) rotate(0deg)", opacity: 0 },
                        "100%": { transform: "translateY(0px) rotate(0deg)", opacity: 1 },
                      },
                      "@keyframes slideDown": {
                        "0%": { transform: "translateY(-10px) rotate(0deg)", opacity: 0 },
                        "100%": { transform: "translateY(0px) rotate(0deg)", opacity: 1 },
                      },
                      animation: isNearBottom ? "spinUp 0.5s ease-out" : "slideDown 0.5s ease-out",
                      "&:hover": {
                        backgroundColor: "#2d0a56",
                        transform: "scale(1.1)",
                      },
                      "& svg": {
                        animation: isNearBottom
                          ? "keyframes { from { transform: translateY(0); } to { transform: translateY(-4px); } } 2s ease-in-out infinite"
                          : "keyframes { from { transform: translateY(0); } to { transform: translateY(4px); } } 2s ease-in-out infinite",
                      }
                    }}
                    aria-label={isNearBottom ? "back to top" : "go to pagination"}
                    title={isNearBottom ? "Back to Top" : "Go to Pagination"}
                  >
                    {isNearBottom ? (
                      <KeyboardArrowUp size="small" sx={{ fontSize: { xs: 28, md: 32 } }} />
                    ) : (
                      <KeyboardArrowDown size="small" sx={{ fontSize: { xs: 28, md: 32 } }} />
                    )}
                  </Fab>
                )}
              </>
            )}
          </Box> : <Box sx={{ height: "30%" }}></Box>
          }
          {cartDetails?.length !== 0 ? <SummaryStickySection /> : null}
          <FooterNote />
          <Footer />{" "}
        </>
      ) : (
        <LoaderComp />
      )}
    </Box>
  );
};

export default ProductPage;